import { z } from "zod";
import { ImportJobStatus, LESSON_IMPORT_MAX_PAGES } from "./import.ts";

/**
 * Ручки комнаты для вставки материалов на доску урока
 * (`docs/room-material-insert-design.md`, раздел 4): право ученикам на файлы и
 * список заданий урока для восстановления после перезагрузки вкладки.
 *
 * Отдельным файлом, а не строками в `./import.ts`: право на файл выдаётся и
 * картинке, видео и аудио, у которых задания нарезки нет вовсе, то есть это
 * контракт доски, а не импорта.
 */

/**
 * `POST /v1/lessons/:lessonId/board-files`, только выдача права, повтор
 * безопасен (3.5). `jobId` у страниц PDF, `null` у файла без подготовки.
 *
 * Потолок списка тот же, что у страниц за одну вставку (Р3): больше файлов за
 * одно нажатие не бывает, а вставка одна за раз. Число одно, иначе окно
 * отпускало бы вставку, которой ручка откажет.
 */
export const BoardFilesRequest = z.object({
  jobId: z.string().uuid().nullable(),
  fileIds: z.array(z.string().uuid()).min(1).max(LESSON_IMPORT_MAX_PAGES),
});
export type BoardFilesRequest = z.infer<typeof BoardFilesRequest>;

/**
 * `GET /v1/lessons/:lessonId/material-jobs` (3.7): задания этой комнаты,
 * живые, `done` и `failed`, ещё не убранные преподавателем. Статус тот же,
 * что у опроса задания, и собирается тем же кодом (`routes/import-status.ts`).
 */
export const MaterialJobsResponse = z.array(ImportJobStatus);
export type MaterialJobsResponse = z.infer<typeof MaterialJobsResponse>;
